import React from 'react';
import SpreadReadingPage from './SpreadReadingPage';

const config = {
  pickerPage: 'celtic',
  path: '/celtic-cross-tarot/',
  spreadId: 'celticCrossClassic',
  cardCount: 10,
  tagline: 'Free Celtic Cross Tarot Reading',
  metaTitle: 'Free Celtic Cross Tarot Reading Online - 10 Card Spread | NowTarot AI',
  metaDescription:
    'Get a free Celtic Cross tarot reading online. The classic 10-card spread covering your situation, challenges, hopes, fears, and final outcome. No signup required.',
  metaKeywords:
    'celtic cross tarot, celtic cross reading, 10 card tarot spread, free celtic cross, celtic cross tarot reading online',
  heading: 'Celtic Cross Tarot Reading',
  blurb: 'Draw 10 cards for the full Celtic Cross.',
  intro:
    'The Celtic Cross is the most famous spread in tarot — ten cards that examine your situation from every angle: the present, the challenge crossing you, the foundation beneath it all, your hopes and fears, and the most likely outcome. Get the full reading here, 100% free with no signup.',
  howItWorks:
    'Focus on your question, shuffle the deck, and pick ten cards. The first six form the cross — your present, challenge, foundation, recent past, best possible outcome, and near future. The final four form the staff: your attitude, external influences, hopes and fears, and the final outcome.',
  deckHeading: 'Draw Your 10 Cards',
  contentSections: [
    {
      heading: 'The Ten Positions of the Celtic Cross',
      items: [
        {
          title: 'The Cross (Cards 1–6)',
          text: 'The heart of the reading. Your present situation and the challenge crossing it, the foundation of the matter, influences passing away, your crown of goals and aspirations, and what is coming into being in the near future.',
        },
        {
          title: 'The Staff (Cards 7–10)',
          text: 'The context around you. How you see yourself in the situation, how others see you and what external forces are at play, your innermost hopes and fears, and finally — the most likely outcome if the current course holds.',
        },
        {
          title: 'Reading the Whole Picture',
          text: 'The power of the Celtic Cross is in the connections: does the outcome card echo the crown or the fear? Does the challenge repeat a pattern from the foundation? Read the cards as one story, not ten separate answers.',
        },
      ],
    },
    {
      heading: 'When to Choose the Celtic Cross',
      items: [
        {
          title: 'Big, Complex Questions',
          text: 'Life transitions, long-standing situations, and decisions with many moving parts deserve more than a quick draw. The Celtic Cross gives every angle its own card.',
        },
        {
          title: 'When Short Readings Raise More Questions',
          text: 'If a 3-card reading left you wanting the "why" behind the answer, the Celtic Cross fills in the backstory: foundations, external influences, and your own hopes and fears.',
        },
        {
          title: 'Periodic Deep Check-ins',
          text: 'Many readers do a Celtic Cross monthly or at meaningful turning points — birthdays, new years, new jobs — as a full-spectrum snapshot of where life stands.',
        },
      ],
    },
  ],
  faqHeading: 'Celtic Cross FAQ',
  faq: [
    {
      question: 'What is the Celtic Cross tarot spread?',
      answer:
        'The Celtic Cross is a classic 10-card tarot spread that examines a question from multiple angles: your present situation, the immediate challenge, the foundation of the matter, past influences, goals, the near future, your attitude, external influences, hopes and fears, and the final outcome.',
    },
    {
      question: 'Is the Celtic Cross good for beginners?',
      answer:
        'It is the deepest spread on our site, but our reader interprets every position for you automatically, so beginners are welcome. If you prefer to start simpler, try the 3-card Past Present Future spread first and come back when you want more detail.',
    },
    {
      question: 'What questions work best with the Celtic Cross?',
      answer:
        'Substantial, open-ended questions: "What do I need to understand about this chapter of my life?", "What is really going on in my career?", or "What surrounds this relationship?" Simple yes-or-no questions are better served by our one-card Yes or No reading.',
    },
    {
      question: 'Is this Celtic Cross reading free?',
      answer:
        'Yes! This Celtic Cross tarot reading is 100% free with no signup or credit card required. Draw as many readings as you like. For deeper, personalized guidance, ask our AI tarot reader in chat.',
    },
  ],
  crossLinks: (
    <>
      Short on time? Try a <a href="/three-card-tarot/" style={{ color: '#FFD700' }}>3-card past, present, future</a> reading,
      ask a <a href="/yes-or-no-tarot/" style={{ color: '#FFD700' }}>yes or no tarot</a> question, or study{' '}
      <a href="/tarot-card-meanings/" style={{ color: '#FFD700' }}>tarot card meanings</a> for the cards in your spread — all free.
    </>
  ),
};

const CelticCrossTarot = () => <SpreadReadingPage config={config} />;

export default CelticCrossTarot;
